import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import {
    AuthenticationServiceContextRequest,
    useCompanyGetAdministratedCompaniesQuery,
    useEntitlementsCreateContextTokenMutation,
} from '../../../common/redux/api/web-api'
import { useApplyOrganisationSelection } from '../../../common/hooks/useApplyOrganisationSelection'
import useText from '../../../common/hooks/useText'
import { AppDispatch, RootState } from '../../redux/store'
import { selectIsConfirmedScopedAccessActive } from '../../redux/features/scopedAccessSession/scopedAccessSessionSlice'
import { Dropdown } from '../../../common/uikit/Dropdown'
import { clearEntitlements } from '../../../common/redux/features/entitlements/entitlementsSlice'
import { useToast } from '../../../common/uikit/ToastProvider'

export const HeaderChangeOrganisationDropdown = () => {
    const text = useText()
    const navigate = useNavigate()
    const toast = useToast()
    const dispatch = useDispatch<AppDispatch>()
    const applyOrganisationSelection = useApplyOrganisationSelection()
    const isConfirmedScopedAccessActive = useSelector(selectIsConfirmedScopedAccessActive)

    const { data: organisations, isLoading } = useCompanyGetAdministratedCompaniesQuery()
    const [getEntitlements] = useEntitlementsCreateContextTokenMutation()

    const organisationOptions = organisations?.map((organisation) => ({
        label: organisation?.name,
        value: organisation?.id,
    }))

    const signedInUser = useSelector((state: RootState) => state.user)
    const handleChangeOrganisation = async (companyId: string): Promise<void> => {
        if (!signedInUser || !signedInUser.selectedCompanyId) {
            navigate('/login', { replace: true })
            return
        }

        try {
            const authenticationServiceContextRequest: AuthenticationServiceContextRequest = {
                organizationId: companyId ?? '',
            }
            await getEntitlements({ authenticationServiceContextRequest }).unwrap()

            await applyOrganisationSelection({
                organizationId: companyId,
            })
        } catch {
            dispatch(clearEntitlements())
            toast.notifyError(text('lblCouldNotGetEntitlements'))
        }
    }

    return (
        <Dropdown
            className="w-10rem md:w-auto"
            id="organisation-select"
            options={organisationOptions}
            value={signedInUser?.selectedCompanyId}
            onChange={(event) => void handleChangeOrganisation(event.value)}
            loading={isLoading}
            disabled={isLoading || isConfirmedScopedAccessActive}
            disabledReason={
                isConfirmedScopedAccessActive ? text('msgScopedAccessOrganisationSwitchDisabled') : undefined
            }
            filter
            placeholder={text('lblSelectOrganisation')}
            showClear={false}
        ></Dropdown>
    )
}
